import * as styles from "./KnobIndicator.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { useKnobContext } from "./Knob.context";
import type { KnobIndicatorProps } from "./Knob.types";

export function KnobIndicator({ className }: KnobIndicatorProps): JSX.Element {
  const { percent, diameter, radius, strokeWidth } = useKnobContext();
  const center = diameter / 2;
  const circumference = 2 * Math.PI * radius;

  return (
    <circle
      data-slot="knob-indicator"
      className={clsx(styles.indicator, className)}
      cx={center}
      cy={center}
      r={radius}
      strokeWidth={strokeWidth}
      fill="none"
      strokeDasharray={circumference}
      strokeDashoffset={circumference * (1 - percent)}
    />
  );
}
